import React from "react";
import { Link } from "react-router-dom";
import { useState, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCountries } from "./countriesSlice";
import { fetchCountries } from "./countriesSlice";
import Input from "@material-ui/core/Input";
import SearchIcon from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";

// import Fade from "react-reveal/Fade";

/////////////////////////////////////////////
// import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";

import AccordionActions from "@material-ui/core/AccordionActions";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InsertChartIcon from "@material-ui/icons/InsertChart";

import Button from "@material-ui/core/Button";
import "./countries.css";

function Countries() {
  const [filterText, setFilterText] = useState("");
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const searchCountry = (e) => {
    setFilterText(e.target.value.toLowerCase());
  };

  const dispatch = useDispatch();
  useLayoutEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  const info = useSelector(selectCountries);

  if (info.error) {
    return <div>{info.error}</div>;
  }

  if (info.isLoading) {
    return (
      <div className="loading">
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Input
        type="search"
        disableUnderline={true}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        placeholder="Type name of country to search"
        onKeyUp={searchCountry}
        style={{ width: "90vw", padding: "20px" }}
      />
      <div className="accordionContainer">
        {info.countries
          .filter((x) => x.country.toLowerCase().includes(filterText))
          .map((res) => (
            <Accordion
              expanded={expanded === res.country}
              onChange={handleChange(res.country)}
              key={res.country}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <div>
                  <div className="SummaryDisp">
                    <div className="SummaryCont1">
                      <img
                        src={res.countryInfo.flag}
                        alt="country flag"
                        loading="lazy"
                        width="50px"
                      />
                    </div>
                    <div className="SummaryCont2">
                      <div> {res.country}</div>
                    </div>
                    <div className="SummaryCont2">
                      population: {res.population.toLocaleString()}
                    </div>
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Cases: {res.cases.toLocaleString()}&nbsp;&nbsp;Recovered:{" "}
                {res.recovered === 0 ? "N/A" : res.recovered.toLocaleString()} |
                Deaths: {res.deaths.toLocaleString()} | Active:{" "}
                {res.active.toLocaleString()} | Deaths per million:{" "}
                {res.deathsPerOneMillion.toLocaleString()} | Today's cases:{" "}
                {res.todayCases.toLocaleString()} | Today's deaths:{" "}
                {res.todayDeaths.toLocaleString()} | Tests per million:{" "}
                {res.testsPerOneMillion.toLocaleString()}
              </AccordionDetails>
              {/* <Divider /> */}
              <AccordionActions>
                <Link
                  to={"/countrieschart/" + res.country}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    endIcon={<InsertChartIcon />}
                  >
                    Chart
                  </Button>
                </Link>
              </AccordionActions>
            </Accordion>
          ))}
      </div>
    </>
  );
}

export default Countries;
